import { request } from "../libs";
import { throws } from "../utils";

export default function refreshToken() {
	const accessToken = localStorage.getItem("access_token");
	const refreshToken = localStorage.getItem("refresh_token");

	if (!accessToken || !refreshToken) {
		throws.missingToken();
	}

	return request(
		"/server/auth/refresh-token",
		{
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ accessToken, refreshToken })
		}
	)
		.then(response => response.json())
		.then(body => {
			localStorage.setItem("access_token", `Bearer ${body.accessToken.token}`);
			localStorage.setItem("refresh_token", body.refreshToken.token);
			return body;
		});
}



// WEBPACK FOOTER //
// ./src/api/refresh-token.js